export const getKuraBucketFileSignedUrl = async (
  url, 
  token,
  bucket,
  key,
  initialKey,
  groupRoomId,
) => {
  try {
    // const result = await fetch(url + `/kura-bucket-file/kura-bucket-file-signed-url/?bucket=${bucket}&key=${key}&initialKey=${initialKey}&groupRoomId=${groupRoomId}`, {
    const result = await fetch(url + `/kura-bucket-file/kura-bucket-file-signed-url/?bucket=${bucket}&key=${encodeURIComponent(key)}&initialKey=${encodeURIComponent(initialKey)}&groupRoomId=${groupRoomId}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (resData?.message === 'bucket-object-not-found') {
      throw new Error(resData.message)
    }

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};


export const getUploadedKuraBucketFile = async (
  url, 
  token,
  bucket,
  key,
  initialKey,
  groupRoomId,
) => {
  try {
    // const result = await fetch(url + `/kura-bucket-file/uploaded-kura-bucket-file/?bucket=${bucket}&key=${key}&initialKey=${initialKey}&groupRoomId=${groupRoomId}`, {
    const result = await fetch(url + `/kura-bucket-file/uploaded-kura-bucket-file/?bucket=${bucket}&key=${encodeURIComponent(key)}&initialKey=${encodeURIComponent(initialKey)}&groupRoomId=${groupRoomId}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (resData?.message === 'bucket-object-not-found') {
      throw new Error(resData.message)
    }

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};